// src/elevarDataLayer.vbt.js
var LOCAL_STORAGE_KEY_MURAD_USER_LOYALTY_DATA = "muradUserLoyaltyData";
var LOCAL_STORAGE_KEY_MURAD_LAST_LOYALTY_SESSION = "muradUserLoyaltyLastSession";
function addLoyaltyUserData() {
  const cachedLoyaltyData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY_MURAD_USER_LOYALTY_DATA) ?? "{}"
  );
  const LOCAL_STORAGE_KEY = "muradAftershipEDD";
  const getIPAddressFromEDD = () => {
    try {
      const localStorageEDD = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (localStorageEDD) {
        const localStorageEDDParsed = JSON.parse(localStorageEDD);
        return localStorageEDDParsed.edd?.data?.sourceIp;
      }
      return void 0;
    } catch (err) {
      throw err;
    }
  };
  window.ElevarTransformFn = (item) => {
    if (item.event === "dl_user_data") {
      return {
        ...item,
        user_properties: {
          ...item.user_properties,
          // ip_address: getIPAddressFromEDD(),
          loyalty: {
            loyalty_email: cachedLoyaltyData?.email,
            loyalty_created_at: cachedLoyaltyData?.created_at,
            // loyalty_status: cachedLoyaltyData?.isMember,
            loyalty_points_earned: cachedLoyaltyData?.pointsEarned,
            loyalty_points_balance: cachedLoyaltyData?.pointsBalance,
            loyalty_tier: cachedLoyaltyData?.vipTier
          }
        }
      };
    } else {
      return item;
    }
  };
}
function retrieveCacheLoyaltyData() {
  const cacheLoyaltyData = () => {
    const {
      email,
      created_at,
      isMember,
      vipTier,
      pointsEarned,
      pointsBalance
    } = window.Swell.Customer.getCustomerDetails();
    const loyaltyData = {
      email,
      created_at,
      // isMember,
      pointsEarned,
      pointsBalance,
      vipTier
    };
    localStorage.setItem(
      LOCAL_STORAGE_KEY_MURAD_USER_LOYALTY_DATA,
      JSON.stringify(loyaltyData)
    );
    if (email) {
      const lastSession = {
        email,
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      localStorage.setItem(
        LOCAL_STORAGE_KEY_MURAD_LAST_LOYALTY_SESSION,
        JSON.stringify(lastSession)
      );
    }
  };
  document.addEventListener("swell:setup", () => cacheLoyaltyData());
}
function handleElevarLoyalty() {
  addLoyaltyUserData();
  retrieveCacheLoyaltyData();
}
handleElevarLoyalty();
